import { network } from 'services/network';

export const uploadCardFile = (params) => {
    const formData = new FormData();
    if (params.file !== null) {
        if (typeof params.file.size !== 'undefined') {
            formData.append('file', params.file, params.file.name);
        }
    }

    params.tags && formData.append('tags', JSON.stringify(params.tags));
    params.assignee && formData.append('assignee', JSON.stringify(params.assignee));
    params.versionDbId && formData.append('versionDbId', JSON.stringify(params.versionDbId));

    return network
        .post('api/bo/uploadCardFile', formData, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((response) => {
            return response.data;
        });
};
